(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["verkaufsstart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('verkaufsstart-countdown')) {
    customElements.define(
      'verkaufsstart-countdown',
      class VerkaufsstartCountdown extends HTMLElement {
        connectedCallback() {
          this.due = new Date(this.dataset.due).getTime();
          if (!this.due) return;
          this.tick();
          this.interval = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.interval);
        }

        tick() {
          const rest = Math.floor((this.due - Date.now()) / 1000);
          if (rest <= 0) {
            clearInterval(this.interval);
            this.textContent = 'wenigen Sekunden …';
            // Einmal neu laden, damit Bestand/Kaufbutton frisch vom Server kommen.
            // Schutz gegen Reload-Schleifen, falls eine gecachte Seite noch den Countdown enthält.
            const key = 'verkaufsstart-reload-' + this.dataset.due;
            try {
              if (!sessionStorage.getItem(key)) {
                sessionStorage.setItem(key, '1');
                setTimeout(() => location.reload(), 1500);
              }
            } catch (e) {}
            return;
          }
          const pad = (n) => String(n).padStart(2, '0');
          const tage = Math.floor(rest / 86400);
          const std = Math.floor((rest % 86400) / 3600);
          const min = Math.floor((rest % 3600) / 60);
          const sek = rest % 60;
          const tageText = tage > 0 ? `${tage} ${tage === 1 ? 'Tag' : 'Tage'} ` : '';
          this.textContent = `${tageText}${pad(std)}:${pad(min)}:${pad(sek)}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
